import useOfferUrl from 'hooks/Offers/useOfferUrl'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import { getMaxGuestCount } from 'lib/offer/occupancyUtils'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import { rem } from 'polished'

const StyledImage = styled(Image)`
  width: ${rem(220)};
  height: ${rem(80)};
  object-fit: cover;
`

interface Props {
  offer: App.VillaOffer;
  filters: App.OfferListFilters;
  onClick?: () => void;
}

function HomesVillasMiniTile({
  offer,
  filters,
  onClick,
}: Props) {
  const offerUrl = useOfferUrl(offer, { filters })

  const capacity = useMemo(() => {
    if (offer) {
      const roomRate = offer.lowestPricePackage?.roomRate
      return getMaxGuestCount(roomRate?.capacities)
    }
  }, [offer])

  return <ClickableLink to={offerUrl} onClick={onClick} >
    <Group direction="vertical" gap={8}>
      <StyledImage id={offer.image.id} alt={offer.image.title}/>
      <Group direction="vertical">
        <BodyText variant="medium" weight="bold">{offer?.property.name}</BodyText>
        <Caption colour="neutral-three" variant="medium">Up to {pluralizeToString('Guest', capacity!)}</Caption>
      </Group>
    </Group>
  </ClickableLink>
}

export default HomesVillasMiniTile
